// Styled
import styled from 'styled-components';

const FaqContainer = styled.div`
  
`;

export {
  FaqContainer,
}